// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1YL9w","clinicsSelect":"TableHeading_clinicsSelect__1kChp"};